export default `
  <button class="theme-switcher"><div class="slider" /></button>
`;
